import { SGDAp3Controller } from './components/ap3/ap3';

export function AP3DockRoutes($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider) {
  $stateProvider
    .state('my.ap3', {
      abstract: true,
      template: '<micro-nav-ap3></micro-nav-ap3>',
      data: {
        preventResetFocus: true
      }
    })
    .state('my.ap3.active', {
      url: 'ap3/{path:.*}',
      data: {
        preventResetFocus: true
      }
    })
    .state('my.ap3-restart', {
      url: 'ap3-restart',
      template: '',
      data: {
        preventResetFocus: true
      },
      controller: SGDAp3Controller
    });
}



// WEBPACK FOOTER //
// ./app/lib/ap3/routes.ts